import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/core/models/usuario.model';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { BackgroundImageService } from 'src/app/core/services/background-image.service';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { EmpresaResponse } from 'src/app/core/models/response/empresa-response.model';
import { UsuarioResponse } from 'src/app/core/models/response/usuario-response.model';
import { LoginResponse } from 'src/app/core/models/response/login-response.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  img: string = '';
  usuario: Usuario = new Usuario();
  value!: string;
  usuarioIncorreto: boolean = false;
  empresaErro: boolean = false;
  telefoneFaleConosco: string;
  tokenAcesso: string;
  paramTokenAcesso: boolean = true;
  loading: boolean = false;
  loadingEmpresa: boolean = false;
  imagemLogoBase64: any;

  constructor(
    private backgroundImageService: BackgroundImageService,
    private weblabService: WeblabService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit(): void {
    this.img = this.backgroundImageService.randonImage();

    this.tokenAcesso = this.route.snapshot.params['chave'];
    this.paramTokenAcesso = !!this.tokenAcesso;

    if (this.paramTokenAcesso) this.getEmpresa();
    else this.authenticationService.limparCacheEmpersa();

    this.authenticationService.tokenExpiradoEmit(false);
  }

  selecionarCodigoEmpresa() {
    this.getEmpresa();
  }

  getEmpresa() {
    let empresa = this.authenticationService.obterEmpresa;

    if (empresa && this.tokenAcesso === empresa.token_acesso) {
      this.getEmpresaSucesso(empresa);

      return;
    }

    this.loadingEmpresa = true;
    this.weblabService.getEmpresa(this.tokenAcesso).subscribe(
      (empresa: EmpresaResponse) => this.getEmpresaSucesso(empresa),
      (erro: any) => this.getEmpresaErro(erro));
  }

  private getEmpresaSucesso(empresa: EmpresaResponse) {
    this.telefoneFaleConosco = empresa.celular_whatsapp_laboratorio;

    empresa.token_acesso = this.tokenAcesso;
    this.imagemLogoBase64 = empresa.logo_laboratorio;
    this.authenticationService.salvarEmpresa(empresa);

    this.loadingEmpresa = false;
    this.empresaErro = false;
    this.paramTokenAcesso = !!this.tokenAcesso;
  }

  private getEmpresaErro(erro: any) {
    setTimeout(() => {
      this.loadingEmpresa = false;
      this.paramTokenAcesso = false;
      this.empresaErro = true;
    }, 1000);
  }

  logar() {
    this.usuario.senha = this.usuario?.senha.replace(/^\s+|\s+$/g, '');
    if (!this.usuario?.email || !this.usuario?.senha || !this.tokenAcesso) return;

    this.usuarioIncorreto = false;
    this.loading = true;

    this.weblabService.login(this.usuario, this.tokenAcesso).subscribe({
      next: (token: LoginResponse) => this.loginSucesso(token),
      error: (erro: any) => this.loginErro(erro),
    });
  }

  private loginSucesso(token: LoginResponse) {
    this.authenticationService.salvarToken(token);
    this.authenticationService.tokenExpiradoEmit(false);
    this.buscaUsuarioLogado();
  }

  private loginErro(erro: any) {
    this.usuarioIncorreto = true;
    this.loading = false;
  }

  buscaUsuarioLogado() {
    this.weblabService.getUsuario().subscribe({
      next: (usuario: UsuarioResponse) => this.getUsuarioSucesso(usuario),
      error: (erro: any) => this.getUsuarioErro(erro),
    });
  }

  private getUsuarioSucesso(usuario: UsuarioResponse) {
    this.authenticationService.salvarUsuarioLogado(this.usuario.email, usuario);
    this.loading = false;
    this.router.navigate([environment.router.dashboard]);
  }

  private getUsuarioErro(erro: any) {
    if (erro.error?.empresa_usuario_weblab) {
      this.authenticationService.salvarUsuarioLogado(this.usuario.email, {
        empresa_usuario_oticomlab: erro.error.empresa_usuario_weblab,
        usuario_oticomlab: erro.error.usuario_weblab
      });
    }

    this.loading = false;
    this.router.navigate([environment.router.dashboard]);
  }

  changeEmail() {
    this.authenticationService.email = this.usuario.email;
  }
}